"use client";

import { Trash2 as TrashIcon } from "lucide-react";
import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { useI18n } from "@/providers/i18n";

export function DeleteConfirmDialog({
  open,
  onOpenChange,
  selectedCount,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCount: number;
  onConfirm: () => void;
}) {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-sidebar/95 backdrop-blur-2xl border border-sidebar-border shadow-none rounded-2xl p-0 gap-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-2 bg-sidebar/40 backdrop-blur-2xl text-left">
          <DialogTitle className="text-base font-semibold tracking-tight flex items-center gap-2">
            <TrashIcon size={16} className="text-destructive" />
            {t("Confirm deletion")} {`(${selectedCount || 0})`}
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground pt-1">
            {t("If you delete by mistake, you can use Ctrl + Z to undo.")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="px-6 pb-6 pt-4 gap-2 sm:gap-2">
          <Button
            variant="outline"
            className="rounded-lg h-9 px-4 text-xs font-bold mt-0 hover:bg-sidebar-accent/30 shadow-none"
            onClick={() => onOpenChange(false)}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="destructive"
            className="rounded-lg h-9 px-4 text-xs font-bold shadow-none"
            onClick={() => {
              try {
                onConfirm();
              } finally {
                onOpenChange(false);
              }
            }}
          >
            {t("Delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
